<template>
    <div class="big_box">
        <div class="img_53 title_center"></div>
        <div class="img_50 content_center"></div>
        <div class="button">
            <div class="img_44 cursor left_button" @click="$emit('close','ok')"></div>
            <div class="img_42 cursor right_button" @click="$emit('close')"></div>
        </div>
    </div>
</template>

<script>
module.exports = {
    props: ['data'],
    data() {
        return {}
    },
    created() {
        console.log('err', this.data)
    },
}
</script>

<style scoped>
.content_text {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 100%;
    text-align: center;
    transform: translate(-50%, -50%);
    font-size: 0.36rem;
    color: #000000;
}
</style>